'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { Body, Button, Caption, Drawer, DrawerContent, DrawerDescription, DrawerTitle, H5, Input, Label } from '@material-bank/mb3-components';
import { BellIcon } from '@material-bank/mtag-icons';
import { useTranslations } from '@material-bank/i18n';
import { useComingSoonDrawer } from './ComingSoonDrawerProvider';
import { useOverlayThemeColor } from '../../hooks/useOverlayThemeColor';
function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
export function ComingSoonDrawer() {
  const $ = _c(74);
  const {
    isOpen,
    close
  } = useComingSoonDrawer();
  useOverlayThemeColor(isOpen);
  const t = useTranslations("comingSoon");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  let t0;
  let t1;
  if ($[0] !== isOpen) {
    t0 = () => {
      if (!isOpen) {
        setEmail("");
        setError("");
      }
    };
    t1 = [isOpen];
    $[0] = isOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== close || $[4] !== email || $[5] !== t) {
    t2 = function submitHandler() {
      if (!isValidEmail(email)) {
        setError(t("invalidEmail"));
        return;
      }
      setError("");
      console.log("Coming soon notification email:", email);
      close();
    };
    $[3] = close;
    $[4] = email;
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const submitHandler = t2;
  let t3;
  if ($[7] !== close) {
    t3 = function openChangeHandler(open) {
      if (!open) {
        close();
      }
    };
    $[7] = close;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const openChangeHandler = t3;
  const showError = !!error;
  let t4;
  if ($[9] !== t) {
    t4 = t("title");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <DrawerTitle className="sr-only">{t4}</DrawerTitle>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("description");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <DrawerDescription className="sr-only">{t6}</DrawerDescription>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("title");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <H5>{t8}</H5>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("description");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10) {
    t11 = <Body variant="small" className="text-muted-foreground">{t10}</Body>;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t9) {
    t12 = <div className="flex flex-col gap-2">{t9}{t11}</div>;
    $[25] = t11;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("emailLabel");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13) {
    t14 = <Label htmlFor="coming-soon-email">{t13}</Label>;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t) {
    t15 = t("emailPlaceholder");
    $[32] = t;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const t16 = showError ? "destructive" : "default";
  let t17;
  if ($[34] !== error) {
    t17 = e => {
      setEmail(e.target.value);
      if (error) {
        setError("");
      }
    };
    $[34] = error;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  const t18 = showError ? "coming-soon-email-error" : undefined;
  let t19;
  if ($[36] !== email || $[37] !== showError || $[38] !== t15 || $[39] !== t16 || $[40] !== t17 || $[41] !== t18) {
    t19 = <Input id="coming-soon-email" type="email" placeholder={t15} value={email} variant={t16} onChange={t17} aria-required={true} aria-invalid={showError} aria-describedby={t18} />;
    $[36] = email;
    $[37] = showError;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== error || $[44] !== showError) {
    t20 = showError && <Caption id="coming-soon-email-error" className="text-red-500">{error}</Caption>;
    $[43] = error;
    $[44] = showError;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t14 || $[47] !== t19 || $[48] !== t20) {
    t21 = <div className="flex flex-col gap-1.5">{t14}{t19}{t20}</div>;
    $[46] = t14;
    $[47] = t19;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <BellIcon size={18} />;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t) {
    t23 = t("notifyMe");
    $[51] = t;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== submitHandler || $[54] !== t23) {
    t24 = <Button size="lg" className="w-full rounded-full" data-haptic="medium" onClick={submitHandler}>{t22}{t23}</Button>;
    $[53] = submitHandler;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t) {
    t25 = t("noThanks");
    $[56] = t;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== close || $[59] !== t25) {
    t26 = <Button variant="outline" size="lg" className="w-full rounded-full" data-haptic="light" onClick={close}>{t25}</Button>;
    $[58] = close;
    $[59] = t25;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t24 || $[62] !== t26) {
    t27 = <div className="flex flex-col gap-2">{t24}{t26}</div>;
    $[61] = t24;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== t12 || $[65] !== t21 || $[66] !== t27) {
    t28 = <DrawerContent className="max-h-[85vh] rounded-t-[20px] flex flex-col"><div className="flex flex-col gap-6 px-6 pt-2 pb-8">{t12}{t21}{t27}</div></DrawerContent>;
    $[64] = t12;
    $[65] = t21;
    $[66] = t27;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== isOpen || $[69] !== openChangeHandler || $[70] !== t28 || $[71] !== t5 || $[72] !== t7) {
    t29 = <Drawer open={isOpen} onOpenChange={openChangeHandler}>{t5}{t7}{t28}</Drawer>;
    $[68] = isOpen;
    $[69] = openChangeHandler;
    $[70] = t28;
    $[71] = t5;
    $[72] = t7;
    $[73] = t29;
  } else {
    t29 = $[73];
  }
  return t29;
}